






























































































declare var window: any;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Navigator from './Navigator.vue';
import Resume from './Resume.vue';
import Address from './Address.vue';
import WorkExperience from './WorkExperience.vue';
import Skills from './Skills.vue';
import MyDocuments from '@/components/MyProfile/MyDocuments.vue';
import ProfessionalReference from './ProfessionalReference.vue';
import CertificationQuestioner from './CertificationQuestioner.vue';
import MissingMandatory from './MissingMandatory.vue';
import ProfilePicture from './ProfilePicture.vue';
import Header from './Header.vue';
import { vxm } from '@/store.vuex';
import ProgressBar from '@/components/Commons/ProgressBar.vue';
import EducationHistory from '@/components/Commons/EducationHistory.vue';
import UserPreference from '@/components/MyProfile/WorkPreference.vue';
import ContinueScreen from './ContinueScreen.vue';
import AdditionalDocuments from '@/components/MyProfile/AdditionalDocuments.vue';
import ErrorModal from '@/components/Commons/ErrorModal.vue';
import MissingMandatoryStep from '@/components/GuidedSignup/MissingMandatoryStep.vue';
import RoleSelection from '@/components/GuidedSignup/RoleSelection.vue';
import SourceType from '@/components/GuidedSignup/SourceType.vue';
import Language from '@/components/MyProfile/Language.vue';
import ProtectedInformation from '@/components/MyProfile/ProtectedInformation.vue';
import WereYouReferred from './WereYouReferred.vue';
import { GSU_STEP_NAME_MAPPER } from './GSUConstants';

const FINAL_STEP_NAME = 'FINAL';
const STEP_NAME_MAPPER = GSU_STEP_NAME_MAPPER;

@Component({
  components: {
    RoleSelection,
    EducationHistory,
    Resume,
    ProfessionalReference,
    CertificationQuestioner,
    MissingMandatory,
    Navigator,
    'user-address': Address,
    protected_information: ProtectedInformation,
    WorkExperience,
    Skills,
    MyDocuments,
    ProfilePicture,
    'guided-signup-header': Header,
    ProgressBar,
    UserPreference,
    ContinueScreen,
    AdditionalDocuments,
    ErrorModal,
    MissingMandatoryStep,
    SourceType,
    Language,
    'were-you-referred': WereYouReferred,
  },
})
export default class Wrapper extends Vue {
  @Prop() openSectionIndex;
  @Prop() openSection;
  private disableNext = true;
  private isFinished = false;
  private nextText = '';
  private sections: Array<string> = [];
  private selectedSection: number = 0;
  private showContinueScreen: boolean = false;
  private applicationSubmittedOnce: boolean = false;
  private roleSelected: boolean = false;
  private bus = new Vue();
  private missedMandatoryList: any[] = [];
  private showMissedMandatoryScreen: boolean = false;
  @Watch('selectedSection')
  onChangeStep() {
    vxm.users.getProfileWizardStepInfo();
  }

  get canShowSkipButton() {
    return this.currentStep && this.currentStep.skipEnabled;
  }

  get canShowCloseButton() {
    if (this.currentSection === 'my-documents') {
      const skillsStep =
        this.profileWizardStep.find &&
        this.profileWizardStep.find((step) => step.stepName === 'SKILLS');
      if (skillsStep) {
        return skillsStep.closeEnabled;
      } else {
        return true;
      }
    }
    return this.currentStep && this.currentStep.closeEnabled;
  }

  async mounted() {
    if (vxm.configs.getGlobalConfigValue('GSU_AFTER_JOB_APPLY')) {
      vxm.jobs.setGuidedSignUpOccured(true);
    }
    vxm.utility.setIsNewlyRegisterdUser(false);
    let sections = vxm.jobs.BrandingInfo.GUIDED_SIGNUP_STEPS || [
      'resume',
      'user-address',
      'work-experience',
      'skills',
      'profile-picture',
    ];
    if (!vxm.configs.CanAddNewWorkExperience) {
      const jobHistoryIndex = sections.findIndex(
        (section) => section === 'work-experience',
      );
      jobHistoryIndex !== -1 && sections.splice(jobHistoryIndex, 1);
    }
    this.nextText = this.$t('global-save-continue-text').toString();
    if (this.openSectionIndex) {
      this.selectedSection = Number(this.openSectionIndex);
    }
    await vxm.users.fetchWizardSteps();
    const steps = vxm.users.ProfileWizardSteps.map((step) => {
      const updatedStepName = step.stepName.replace(/_/g, '-').toLowerCase();
      return STEP_NAME_MAPPER[updatedStepName] || updatedStepName;
    });
    if (this.enableRoleBasedGsuSteps) {
      sections = steps;
    } else if (steps) {
      // Check/remove Were You Referred if One time visibility.
      const wyrIndex = steps.findIndex((s) => s === 'were-you-referred');
      if (wyrIndex === -1) {
        sections = sections.filter(
          (sectionName) => sectionName !== 'were-you-referred',
        );
      }
    }
    if (sections.includes('source-type')) {
      const response = await vxm.users.getSourceTypeDetails();
      if (response && response.meta.success) {
        let responseData = response.data.customFields.candidateCustomMetaData;
        const sourceField = responseData[0];
        if (
          sourceField.defaultValue &&
          sourceField.defaultValue.toLowerCase() !== 'engage' &&
          sourceField.defaultValue.toLowerCase() !== 'workllama'
        ) {
          sections = sections.filter(
            (sectionName) => sectionName !== 'source-type',
          );
        }
      }
    }
    if (this.openSection) {
      this.selectedSection = sections.indexOf(this.openSection);
    }
    this.sections = sections;
  }

  get enableRoleBasedGsuSteps() {
    return vxm.configs.getGlobalConfigValue('ENABLE_ROLE_BASED_GSU_STEPS');
  }

  updateRoleSelected(value) {
    this.roleSelected = value;
  }

  updateSections(payload) {
    this.sections = payload;
  }

  get showMyDocumentsSection() {
    return vxm.configs.getGlobalConfigValue('SHOW_MY_DOCUMENTS_SECTION_IN_GUIDED_SIGNUP')
  }

  updateMyDocumentSection() {
    // Show My Documents page only if suporting document are hidden from skill section
    if (!this.showMyDocumentsSection) return;

    // Get existing section index
    const myDocumentsIndex = this.sections.findIndex(
      (section) => section === 'my-documents',
    );
    // Check for required attributes
    let requiredAttributes = vxm.users.myUserProfile.userAttributeSkills;
    if (requiredAttributes && requiredAttributes.length) {
      if (myDocumentsIndex === -1) {
        const skillsIndex = this.sections.findIndex(
          (section) => section === 'skills',
        );
        // Add my document section
        skillsIndex !== -1 &&
          this.sections.splice(skillsIndex + 1, 0, 'my-documents');
      }
    } else if (myDocumentsIndex !== -1) {
      // Remove my document section
      this.sections.splice(myDocumentsIndex, 1);
    }
  }

  async relaunchGuidedSignup() {
    await vxm.users.getProfileWizardStepInfo();
    var missing: any = vxm.users.RequiredStepsInfo.requiredStepsMissing;
    this.selectedSection = this.sections.findIndex((step) => {
      return missing.find((missedStep: any) => {
        if (missedStep.toLowerCase() === 'address') {
          missedStep = 'user-address';
        }
        const stepname = STEP_NAME_MAPPER[missedStep.toLowerCase()];
        if (stepname && step === stepname) {
          return true;
        } else {
          return (
            missedStep.replace(/-|_/g, '').toLowerCase() ===
            step.replace(/-|_/g, '').toLowerCase()
          );
        }
      });
    });
    this.applicationSubmittedOnce = true;
    this.showMissedMandatoryScreen = false;
  }

  openMandatoryStep(step) {
    if (step === 'ADDRESS') {
      step = 'user-address';
    }
    if (step === 'JOB_PREFERENCE') {
      step = 'user-preference';
    }
    this.selectedSection = this.sections.findIndex(
      (section) =>
        section.replace(/-|_/g, '').toLowerCase() ===
        step.replace(/-|_/g, '').toLowerCase(),
    );
  }

  get header() {
    if (this.isFinished) {
      const finalStep = this.getStep(FINAL_STEP_NAME);
      return finalStep && finalStep.sectionHeader
        ? finalStep.sectionHeader
        : this.$t(`guidedsignup.final.header`);
    }
    return this.currentStep && this.currentStep.sectionHeader
      ? this.currentStep.sectionHeader
      : this.$t(`guidedsignup.${this.sections[this.selectedSection]}.header`);
  }

  get isRequiredStep() {
    let currentSection = this.sections[this.selectedSection];
    if (
      currentSection === 'user_address' ||
      currentSection === 'user-address'
    ) {
      currentSection = 'address';
    }

    if (
      currentSection === 'certification-questioner' ||
      currentSection === 'certification_questioner'
    ) {
      currentSection = 'certification';
    }

    const step = this.getStep(currentSection);
    return step && step.stepRequired ? true : false;
  }

  get isLastStep(){
    let currentSection = this.sections[this.selectedSection];
    let lastSection = this.sections[this.sections.length-1];
   return currentSection === lastSection ? true :false;
  }

  get subHeader() {
    if (this.isFinished) {
      const finalStep = this.getStep(FINAL_STEP_NAME);
      return finalStep && finalStep.sectionSubHeader
        ? finalStep.sectionSubHeader
        : this.$t(`guidedsignup.final.subheader`);
    }

    if (this.currentStep && this.currentStep.meta) {
      const stepMeta = JSON.parse(this.currentStep.meta);
      if (vxm.jobs.BrandingInfo.PROFESSIONAL_REFERENCE_PRIMARY_SUBHEADER && stepMeta.minimumEntries > 1) { 
        return `Provide at least ${stepMeta.minimumEntries} supervisor references.`;
      }
      if (stepMeta.minimumEntries > 1) {
        return `Provide at least  ${
          stepMeta.minimumEntries
        } ${this.currentStep.stepName.toLowerCase().replace(/_/g, ' ')}s`;
      }
    }
    return this.currentStep && this.currentStep.sectionSubHeader
      ? this.currentStep.sectionSubHeader
      : this.$t(
          `guidedsignup.${this.sections[this.selectedSection]}.subheader`,
        );
  }

  getStep(stepName: string) {
    return this.profileWizardStep.find((step) => {
      const normalizedStepName = step.stepName.toLowerCase().replace(/_/g, '-');
      return (
        STEP_NAME_MAPPER[normalizedStepName] === stepName ||
        normalizedStepName == stepName
      );
    });
  }

  get currentStep() {
    return this.getStep(this.sections[this.selectedSection]);
  }

  get profileWizardStep() {
    return vxm.users.ProfileWizardSteps;
  }
  updateDisableNext(val) {
    this.updateMyDocumentSection();
    this.disableNext = val;
  }
  async onSkip() {
    vxm.users.Rudderstack.trackEvent("GSU Page Skipped",
      { MissingSteps: vxm.users.RequiredStepsInfo.requiredStepsMissing ,
        gsuPageRequired: this.isRequiredStep,
        gsuSequence: this.selectedSection + 1,
        gsuStepName : this.sections[this.selectedSection]
      });
    if (this.selectedSection >= this.sections.length - 1) {
      this.goToHomePage();
      return;
    }
    this.updateContinueScreen(
      vxm.jobs.BrandingInfo.CONTINUE_SCREEN_INDEX === this.selectedSection,
    );
    this.updateDisableNext(true);
    if (!this.applicationSubmittedOnce) {
      ++this.selectedSection;
      return;
    }
    await vxm.users.getProfileWizardStepInfo();
    if (
      vxm.users.RequiredStepsInfo.requiredStepsMissing.find(
        (step: string) =>
          step.toLowerCase().replace(/-|_/g, '') ===
          this.sections[this.selectedSection].replace(/-|_/g, ''),
      )
    ) {
      this.$modal.show(
        ErrorModal,
        {
          header: this.$t('Wrapper_MandatorySection'),
          onOk: () => {},
        },
        {
          height: 'auto',
          clickToClose: false,
        },
      );
    } else {
      ++this.selectedSection;
    }
  }

  goToNext() {
    if (this.selectedSection >= this.sections.length - 1) {
      this.isFinished = true;
      this.nextText = this.$t('sidemenu.findjobs').toString();
      this.selectedSection = this.sections.length - 1;
      this.sections[this.selectedSection] !== 'profile-picture' &&
        this.goToHomePage();

      return;
    }
    this.updateContinueScreen(
      vxm.jobs.BrandingInfo.CONTINUE_SCREEN_INDEX === this.selectedSection,
    );
    ++this.selectedSection;
    this.updateDisableNext(true);
  }
  onNext() {
    vxm.users.Rudderstack.trackEvent("GSU Submitted", {Missingsteps :vxm.users.RequiredStepsInfo.requiredStepsMissing});
    if (this.isFinished) {
      return this.$router.push({ name: 'Findjobs' });
    }
    this.bus.$emit('on-next-step', {
      section: this.sections[this.selectedSection],
    });
  }
  onCancel() {
    if (this.selectedSection <= 0) {
      return (this.selectedSection = 0);
    }
    --this.selectedSection;
    return;
  }
  get currentSection() {
    return this.sections[this.selectedSection];
  }
  get profileStrength() {
    return vxm.users.myUserProfile.userProfileStrength;
  }
  get role() {
    return vxm.users.myUserProfile.role;
  }

  setMissedMandatoryList(missedMandatorySteps: any[]) {
    this.showMissedMandatoryScreen = true;
    this.missedMandatoryList = missedMandatorySteps;
  }

  updateNextText(text) {
    this.nextText = text;
  }
  updateContinueScreen(val) {
    this.showContinueScreen = val;
  }
  goToHomePage() {
    let homeMenu: any = 'false';
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      homeMenu = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (menu) => menu.sectionKey === 'HOME' && menu.signInVisibility,
      );
    } else {
      homeMenu = vxm.utility.leftMenuOptions.find(
        (menu) => menu.alias === 'home' && menu.signInVisibility,
      );
    }
    if (
      vxm.configs.getGlobalConfigValue('LANDING_PAGE_AFTER_SIGN_IN') === 'FIND_JOBS'
    ) {
      this.$router.push({ path: 'findjobs' });
    } else {
      this.$router.push({ path: homeMenu ? 'home' : 'findjobs' });
    }
  }
}
